import "./App.css";
import React, { useEffect, useState } from "react";
import pic from "./data-not-found-png-yellow.jpg.png";
import pics from "./adoop-img.png";
import { Table } from "react-bootstrap";
import { TableBody, TableRow } from "@mui/material";
import CategoryList from "./CategoryList";
import { useNavigate } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Pricing from "./Pricing";
import ComingSoon from "./ComingSoon";

function App() {

 

  return (
    <>
     <Router>
      <div class="preloader">
        <div class="preloader-inner">
          <div class="preloader-icon">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      <header class="header navbar-area" style={{padding:"20px"}}>
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="nav-inner">
                <nav class="navbar navbar-expand-lg">
                  <a class="navbar-brand" href="https://adoop.in/index.html">
                    <img
                      src="assets/images/logo/black-white-logo.png"
                      alt="Logo"
                    />
                  </a>
                  <button
                    class="navbar-toggler mobile-menu-btn"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                    <span class="toggler-icon"></span>
                  </button>
                  <div
                    class="collapse navbar-collapse sub-menu-bar"
                    id="navbarSupportedContent"
                  >
                    <ul id="nav" class="navbar-nav ms-auto">
                      <li class="nav-item">
                        <a href="/">Home</a>
                      </li>
                      <li class="nav-item">
                        <a href="https://adoop.in/index.html">Features</a>
                      </li>
                      <li class="nav-item">
                        <a href="https://adoop.in/about-us.html">About Us</a>
                      </li>
                        <li class="nav-item">
                        <a href="https://mybiz.adoop.in/pricing">Pricing</a>
                      </li>
                      <li class="nav-item">
                        <a href="https://adoop.in/contact-us.html">Contact
                                            Us</a>
                      </li>
                    </ul>
                  </div>
                  <div class="button add-list-button">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.tes.shoponmobile.promotions.adoop&pcampaignid=web_share"
                      class="btn"
                      target="_blank"
                      contenteditable="false"
                      style={{ cursor: "pointer;" }}
                    >
                      <img
                        src="assets/images//download-btn/playstore.png"
                        class="img-fluid"
                        alt="playstore"
                        style={{ height: "26px", width: "26px" }}
                      />
                    </a>
                    &nbsp; &nbsp;
                    <a
                      href="https://apps.apple.com/in/app/adoop/id6739332196"
                      class="btn"
                      contenteditable="false"
                      style={{ cursor: "pointer;" }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        fill="currentColor"
                        class="bi bi-apple"
                        viewBox="0 0 16 16"
                      >
                        <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                        <path d="M11.182.008C11.148-.03 9.923.023 8.857 1.18c-1.066 1.156-.902 2.482-.878 2.516s1.52.087 2.475-1.258.762-2.391.728-2.43m3.314 11.733c-.048-.096-2.325-1.234-2.113-3.422s1.675-2.789 1.698-2.854-.597-.79-1.254-1.157a3.7 3.7 0 0 0-1.563-.434c-.108-.003-.483-.095-1.254.116-.508.139-1.653.589-1.968.607-.316.018-1.256-.522-2.267-.665-.647-.125-1.333.131-1.824.328-.49.196-1.422.754-2.074 2.237-.652 1.482-.311 3.83-.067 4.56s.625 1.924 1.273 2.796c.576.984 1.34 1.667 1.659 1.899s1.219.386 1.843.067c.502-.308 1.408-.485 1.766-.472.357.013 1.061.154 1.782.539.571.197 1.111.115 1.652-.105.541-.221 1.324-1.059 2.238-2.758q.52-1.185.473-1.282" />
                      </svg>
                    </a>
                    &nbsp; &nbsp;
                    <a href="https://mybiz.adoop.in/" class="btn">
                      Login Now!
                    </a>
                    &nbsp; &nbsp;
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* category list */}
     
       <Routes>
          <Route path="/" element={<CategoryList />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/comingSoon" element={<ComingSoon />} />
          {/* You can add more routes here */}
        </Routes>
      {/* end of category list */}

      {/* footer */}
      <footer class="footer">
        <div class="container">
          <div class="row g-1 align-items-center p-3">
            <div class="col-md-5 text-center text-md-start mb-md-0">
              <span class="text-light">
                <i class="fas fa-copyright me-2"></i>Adoop, All right reserved.{" "}
              </span>
              <a
                href="https://adoop.in/privacy-policy.html"
                class="copyright"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Privacy policy |{" "}            
              </a>

              <a
                href="https://adoop.in/terms-and-conditions.html"
                class="copyright"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                {" "}
                Terms &amp; Conditions |{" "}
              </a>

              <a
                href="https://adoop.in/faq.html"
                class="copyright"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                {" "}
                FAQ
              </a>
            </div>
            <div class="col-md-3">
              <div class="d-flex justify-content-center">
                <a
                  href="#"
                  target="_blank"
                  aria-label="linkdin"
                  class="btn btn-light-outline-0 btn-sm-square rounded-circle me-0"
                  contenteditable="false"
                  style={{ cursor: "pointer;" }}
                >
                  <i class="lni lni-linkedin-original text-light"></i>
                </a>
              </div>
            </div>
            <div class="col-md-4 text-center text-md-end text-white">
              <span class="text-light"> Powered By</span>{" "}
              <a
                class="border-bottom copyright"
                href="https://techexponentsystem.com/"
                contenteditable="false"
                style={{
                  cursor: "pointer;",
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Tech Exponent System
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* end footer */}
      </Router>
    </>
  );
}

export default App;
